import { isObjectEmpty } from "./isObjectEmpty";

export const isObjectHasValue = (object: any = {}, excludedKeys?: string[]) => {
  if (isObjectEmpty(object)) return false;

  for (const key in object) {
    if (excludedKeys?.includes(key)) continue;
    if (object?.[key]) return true;
  }

  return false;
};
